import { Checkbox } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldValue
} from "components/Fields/styled"
import Image from "components/Image"
import CollapsibleTextArea from "components/inputs/CollapsibleTextArea"
import Typography from "components/Typography"

import { ComponentProps } from "."
import {
  Actions,
  Bottom,
  Info,
  Left,
  Middle,
  Name,
  Preview,
  Previews,
  Title,
  Wrapper
} from "./styled"

type PreviewType = ComponentProps["previews"][number]

const renderPreview = (preview: PreviewType) => (
  <Preview key={preview.url}>
    {preview.image ? <img alt={preview.name} src={preview.image} /> : null}

    <Name as="a" href={preview.url} target="__blank">
      {preview.name}
    </Name>
  </Preview>
)

const Draft = ({
  hasAdditionalInstructions,
  homeVideo,
  id,
  image,
  isAdmin,
  isChecked,
  isEditor,
  isGenerateLoading,
  isPublishLoading,
  onChange,
  onView,
  onGenerate,
  onPublish,
  previews,
  textAreaRef,
  title
}: ComponentProps) => (
  <Wrapper>
    <Left>
      <Checkbox
        inputId={id}
        isChecked={isChecked}
        label=""
        name={title}
        onChange={onChange}
        value={id}
      />
    </Left>

    <Middle>
      {image ? <Image {...image} /> : null}

      <Info>
        <Title>{title}</Title>

        <Previews>{previews.map(renderPreview)}</Previews>

        <Bottom>
          {homeVideo ? (
            <FieldLabelAndValue>
              <FieldLabel>{"Home Video"}</FieldLabel>

              <FieldValue>
                <Typography.Link
                  to={`/home-videos/home-videos/${homeVideo.id}`}
                >
                  {homeVideo.name}
                </Typography.Link>
              </FieldValue>
            </FieldLabelAndValue>
          ) : null}

          {hasAdditionalInstructions ? (
            <CollapsibleTextArea
              id={`${id}-additional-instructions`}
              label="Additional Instructions"
              name="additionalInstructions"
              rows={5}
              textAreaRef={textAreaRef}
            />
          ) : null}
        </Bottom>
      </Info>
    </Middle>

    <Actions>
      {onView ? <Button label="View" onClick={onView} /> : null}

      {onGenerate && (isAdmin || isEditor) ? (
        <Button
          disabled={isGenerateLoading}
          label="Generate"
          loading={isGenerateLoading}
          onClick={onGenerate}
          outlined
          secondary
        />
      ) : null}

      {isAdmin || isEditor ? (
        <Button
          disabled={isPublishLoading}
          label="Publish"
          loading={isPublishLoading}
          onClick={onPublish}
          secondary
        />
      ) : null}
    </Actions>
  </Wrapper>
)

export default Draft
